import React, { FC, Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PatientApi from "Service/Patient.api";
import PatientFormatter from "Utils/Patient.Formatter";
import { LoggedTimeType } from "DataTypes/Services/Patient.type";
import {
  PatientInitialStateType,
  UserInitialStateType,
} from "DataTypes/Redux";
import { CMTabSelectedEnrollmentType } from "DataTypes/Modal";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import NoData from "Components/NoData";
import { label } from "Constant/En";
import DateTime from "Utils/DateTime";
import TabPanel1 from "Components/TabPanel/index1";
import ViewLogDetails from "./ViewLogDetails";
import ViewLogPdf from "./ViewLogPdf";

const AddonLogTime: FC<CMTabSelectedEnrollmentType> = ({ prgmDetails }) => {
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { careplanId, programId } = prgmDetails;
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const [rowIndex, setRowIndex] = useState<number>(0);
  const [rows, setRows] = useState<LoggedTimeType[]>([]);
  const [tabIndex, setTabIndex] = useState(1);

  useEffect(() => {
    setData();
  }, []);

  const setData: () => void = async () => {
    const payload = {
      patientId: patientInfo.id,
      userId: myInfo.id,
      state: "addon time",
      programId: programId,
      careplanId: careplanId,
    };
    const res = await PatientApi.TimeLogSearch({ data: payload });
    if (res.success) {
      const data = PatientFormatter.LoggedTimeList(res?.data);
      setRows(data);
    }
  };

  const Layer1 = (
    <Box width="20%" height="100%">
      <Tabs
        value={rowIndex}
        onChange={(event, index) => setRowIndex(index)}
        aria-label="basic tabs example"
        variant="scrollable"
        indicatorColor="secondary"
        orientation="vertical"
        scrollButtons="auto"
        sx={{
          borderRight: "1px solid",
          borderColor: "custom.main",
          height: "100%",
        }}
      >
        {rows.map((el, index) => {
          return (
            <Tab
              sx={{ ...sxFilterPrgmTab }}
              key={el.id}
              label={
                <Box
                  width="100%"
                  sx={{
                    ...(index == rowIndex ? sxListBoxSelected : sxListBox),
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    {el.loggedBy || label.naText}
                  </Typography>
                  <Typography variant="subtitle1">
                    {DateTime.FormatIntoDateTime(el.createdAt)}
                  </Typography>
                </Box>
              }
              id={`simple-tab-${el.id}`}
              aria-controls={`simple-tabpanel-${el.id}`}
            />
          );
        })}
      </Tabs>
    </Box>
  );

  const Layer201 = (
    <Box sx={{ ...sxTabMainBox }}>
      <Tabs
        value={tabIndex}
        onChange={(event, value) => setTabIndex(value)}
        aria-label="basic tabs example"
        variant="scrollable"
        indicatorColor="secondary"
      >
        {[{
          id: 1,
          label: "View Details",
        },
        {
          id: 2,
          label: "View PDF",
        }].map((filEl) => {
          return (
            <Tab
              key={filEl.id}
              value={filEl.id}
              sx={{ ...sxTabTab }}
              label={filEl.label}
              id={`simple-tab-${filEl.id}`}
              aria-controls={`simple-tabpanel-${filEl.id}`}
            />
          );
        })}
      </Tabs>
    </Box>
  );

  const Layer202 = (
    <Box height="90%" px={2} py={1}>
      <TabPanel1 value={1} currentValue={tabIndex}>
        <ViewLogDetails row={rows[rowIndex]} />
      </TabPanel1>
      <TabPanel1 value={2} currentValue={tabIndex}>
        <ViewLogPdf row={rows[rowIndex]} />
      </TabPanel1>
    </Box>
  );

  const Layer2 = (
    <Box width="80%" height="100%" pl={2}>
      {rows.length ?
        rows[rowIndex].addOnTimePath ?
          <Fragment>
            {Layer201}
            {Layer202}
          </Fragment>
          : <ViewLogDetails row={rows[rowIndex]} />
        : <NoData />
      }
    </Box>
  );


  return (
    <Box width="100%" height="100%" display="flex">
      {Layer1}
      {Layer2}
    </Box>
  );
};
export default AddonLogTime;

const sxFilterPrgmTab = {
  minHeight: 0,
  minWidth: 0,
  p: 1,
  textAlign: "start",
  ":hover": {
    backgroundColor: "bg.main"
  },
};

const sxListBox = {
  "& >h6": {
    color: "custom.dark",
  },
};

const sxListBoxSelected = {
  "& >h6": {
    color: "primary.main",
  },
};

const sxTabMainBox = {
  height: "6%",
  px: 2,
  "& >div": {
    borderBottom: 1,
    borderColor: "custom.main",
    minHeight: 0,
    height: "100%",
    "& >div": {
      height: "100%",
      "& >div": {
        height: "100%",
      },
    },
  },
};

const sxTabTab = {
  minHeight: 0,
  minWidth: 0,
  height: "100%",
  fontSize: "0.8rem",
};
